import JobInfoIcon from '@material-ui/icons/TrendingUp';
import JobServerLogIcon from '@material-ui/icons/Dvr';

export default ({
  overviewText = 'Overview',
  overviewIcon = JobInfoIcon,
  getDownloadLogURL,
  getDownloadServerLogURL,
}) => {
  return {
    downloadLog: {
      tooltip: 'Download job log',
      getLink: getDownloadLogURL,
      download: true,
      ariaLabel: 'download license',
      idPrefix: 'download-job-log-',
      label: 'Download log',
    },
    downloadServerLog: {
      tooltip: 'Download server log',
      getLink: getDownloadServerLogURL,
      download: true,
      ariaLabel: 'download server log',
      idPrefix: 'download-server-log-',
      label: 'Download serer log',
      icon: JobServerLogIcon,
    },
    jobDashboard: {
      callbackProp: 'onJobDashboard',
      tooltip: 'Job overview',
      ariaLabel: 'job overview',
      idPrefix: 'job-overview-btn-',
      label: overviewText,
      icon: overviewIcon,
    },
  };
};
